import RestClient from "../rest.client"

export default class CommandsService {
    static async sendCommand(command: string, deviceId: number) {
        console.log(`Sending command ${command} to ${deviceId}`)
        return await RestClient.call({
            url: '/commands/send',
            method: 'post',
            headers: { 'Authorization': localStorage.getItem('token') },
            data: {
                deviceId: deviceId,
                type: "custom",
                attributes: {
                    data: command
                }
            }
        })
    }
} 